const isValidPhoneNumber = (value: string): boolean => {
  const re = /^\+([0-9]{13}|[0-9]{12}|[0-9]{11}|[0-9]{10})$/;
  const isValid: boolean = re.test(value.toLowerCase());
  return isValid;
};

export default isValidPhoneNumber;
